import React from "react";
import { FaHistory, FaSyncAlt, FaUsers, FaUserShield } from "react-icons/fa";

import { formatNumber } from "../utils/leClubUtils";

export default function ClubHero({
  loading,
  stats,
  activeTab,
  onChangeTab,
  onRefresh,
}) {
  const isLoading = loading.team || loading.users || loading.settings;

  return (
    <section className="relative overflow-hidden rounded-[2rem] border border-slate-200 bg-slate-950 p-6 text-white shadow-xl shadow-slate-300/40 dark:border-slate-800 dark:shadow-none lg:p-8">
      <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-orange-500/30 blur-3xl" />
      <div className="absolute -bottom-28 left-1/3 h-72 w-72 rounded-full bg-blue-500/20 blur-3xl" />

      <div className="relative flex flex-col gap-6 xl:flex-row xl:items-end xl:justify-between">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-[0.24em] text-orange-200">
            Le club
          </p>

          <h1 className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl">
            Gestion du club
          </h1>

          <p className="mt-4 max-w-2xl text-sm leading-7 text-slate-300 sm:text-base">
            Gérez les personnes visibles côté visiteur, les comptes
            utilisateurs de l’application et l’historique du club depuis une
            interface unique organisée en panneaux.
          </p>
        </div>

        <div className="grid gap-3 sm:grid-cols-3 xl:min-w-[520px]">
          <div className="rounded-3xl border border-white/10 bg-white/10 p-4 backdrop-blur">
            <p className="text-xs uppercase tracking-[0.18em] text-slate-300">
              Équipe
            </p>
            <p className="mt-2 text-3xl font-bold">
              {isLoading ? "..." : formatNumber(stats.teamTotal)}
            </p>
          </div>

          <div className="rounded-3xl border border-white/10 bg-white/10 p-4 backdrop-blur">
            <p className="text-xs uppercase tracking-[0.18em] text-slate-300">
              Utilisateurs
            </p>
            <p className="mt-2 text-3xl font-bold">
              {isLoading ? "..." : formatNumber(stats.usersTotal)}
            </p>
          </div>

          <div className="rounded-3xl border border-white/10 bg-white/10 p-4 backdrop-blur">
            <p className="text-xs uppercase tracking-[0.18em] text-slate-300">
              Historique
            </p>
            <p className="mt-2 text-3xl font-bold">
              {isLoading ? "..." : formatNumber(stats.historyImages)}
            </p>
          </div>
        </div>
      </div>

      <div className="relative mt-6 flex flex-wrap items-center gap-3">
        <button
          type="button"
          onClick={() => onChangeTab("team")}
          className={`inline-flex items-center gap-2 rounded-2xl px-4 py-2.5 text-sm font-bold transition ${
            activeTab === "team"
              ? "bg-white text-slate-950"
              : "border border-white/10 bg-white/10 text-white hover:bg-white/15"
          }`}
        >
          <FaUsers />
          Équipe
        </button>

        <button
          type="button"
          onClick={() => onChangeTab("users")}
          className={`inline-flex items-center gap-2 rounded-2xl px-4 py-2.5 text-sm font-bold transition ${
            activeTab === "users"
              ? "bg-white text-slate-950"
              : "border border-white/10 bg-white/10 text-white hover:bg-white/15"
          }`}
        >
          <FaUserShield />
          Utilisateurs
        </button>

        <button
          type="button"
          onClick={() => onChangeTab("history")}
          className={`inline-flex items-center gap-2 rounded-2xl px-4 py-2.5 text-sm font-bold transition ${
            activeTab === "history"
              ? "bg-white text-slate-950"
              : "border border-white/10 bg-white/10 text-white hover:bg-white/15"
          }`}
        >
          <FaHistory />
          Historique
        </button>

        <button
          type="button"
          onClick={onRefresh}
          className="inline-flex items-center gap-2 rounded-2xl border border-white/10 bg-white/10 px-4 py-2.5 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-white/15"
        >
          <FaSyncAlt />
          Actualiser
        </button>
      </div>
    </section>
  );
}